import React, { useEffect, useState } from "react";
import { Grid, Card, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
    padding: "2vh",
  },
  card: {
    padding: "2vh",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "12px",
    backgroundColor: "#f9f9f9",
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    padding: theme.spacing(2),
    textAlign: "center",
    borderRadius: "6px",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    minHeight: "10vh",
    marginTop: "1vh",
    opacity: "1",
  },
}));

export default function Dashboard() {
  const classes = useStyles();
  const [tfaDevices, setTfaDevices] = useState({});

  useEffect(() => {
    api.floor.cpmGetDevData().then((res) => {
      const tfaData = res["NONGL_SS_DG"];
      console.log("TFA Devices:", tfaData);
      setTfaDevices(tfaData || {});
    });
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card
            className={classes.paper}
            style={{ maxWidth: "37vw", margin: "0 auto" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "3vw",
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              {Object.entries(tfaDevices)
                .sort(([, a], [, b]) =>
                  (a.name || "").localeCompare(b.name || "")
                )
                .map(([deviceId, deviceInfo]) => {
                  const name = deviceInfo.name || "Unknown";
                  const value =
                    deviceInfo?.Eqp_Attributes?.DG_Battery_Volt_SS
                      ?.presentValue || "N/A";

                  return (
                    <div
                      key={deviceId}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        minWidth: "80px",
                      }}
                    >
                      <Typography variant="h6" style={{ fontWeight: "bold" }}>
                        {name}
                      </Typography>
                      <Typography variant="body2">{value}</Typography>
                    </div>
                  );
                })}
            </div>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
